<template>
  <Modal v-if="visible" size="xl">
    <div class="flex flex-col" style="max-height: 75vh">
      <h3 class="text-blue-700 text-2xl mt-2 mb-3 text-center flex-shrink-0">
        Finalidad del dato
      </h3>
      <hr class="border-t border-blue-200 mb-2 flex-shrink-0" />
      <div class="text-justify pt-3 px-4 overflow-y-auto flex-1">
        <a-timeline>
          <a-timeline-item>
            <div>
              <p>
                La Superintendencia Financiera de Colombia, en cumplimiento de
                la Ley 1581 de 2012 y demás normas concordantes, es responsable
                del tratamiento de los datos personales que por este medio
                recibe, los cuales serán empleados para adelantar las funciones
                de supervisión que tiene a cargo, respecto del cumplimiento, por
                parte de las entidades vigiladas, en la atención y gestión de
                las quejas que contra ellas se formulen, en el marco, de las
                normas de protección al consumidor financiero que permite
                identificar conductas que puedan vulnerar los derechos de los
                consumidores financieros en general y verificar la
                implementación del Sistema de Atención al Consumidor Financiero
                (SAC) por parte de las mismas.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                Entiendo que, como titular de la información tengo derecho a
                conocer, actualizar y solicitar la rectificación de mis datos
                personales y, sólo en los casos en que sea procedente, a
                solicitar la supresión o revocar la autorización otorgada para
                su tratamiento.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                Igualmente, manifiesto que conozco la Política de Tratamiento de
                Datos Personales de la Superintendencia Financiera de Colombia,
                la cual está disponible en la página web
                <a
                  class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600 break-all"
                  target="_blank"
                  rel="noopener"
                  href="https://www.superfinanciera.gov.co/publicaciones/10106783/nuestra-entidadacerca-de-la-sfcpoliticas-de-la-entidadpoliticas-web-10106783"
                  >https://www.superfinanciera.gov.co/publicaciones/10106783/nuestra-entidadacerca-de-la-sfcpoliticas-de-la-entidadpoliticas-web-10106783</a
                >.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                En relación con los Datos Personales recolectados y tratados y
                de acuerdo con la Ley 1581 de 2012, el Decreto 1377 de 2013 y el
                Decreto 1074 de 2015, he sido informado que tengo los derechos
                establecidos en la política de tratamiento de datos de la SFC y
                que los puedo ejercer mediante el correo electrónico
                <a
                  class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600 break-all"
                  href="mailto:super@superfinanciera.gov.co"
                  >super@superfinanciera.gov.co</a
                >, de forma presencial en el punto de atención al ciudadano en
                la Calle 7 No. 4-49 de la ciudad de Bogotá o vía telefónica en
                el número +57 601 5940200.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                Acepto que mis Datos Personales serán eliminados de la base de
                datos de la SFC cuando cumplan con el propósito para el que
                fueron recolectados o al finalizar el término de tiempo
                establecido cuando medie disposición legal.
              </p>
            </div>
          </a-timeline-item>
          <a-timeline-item>
            <div>
              <p>
                Si desea comunicarse con esta Superintendencia para presentar
                una consulta, queja o petición al respecto, los canales
                habilitados son los siguientes:
                <br />
                Centro de Contacto Telefónico (601) 3078042
                <br />
                WhatsApp 317 6398781 Código Postal: 111711
                <br />
                Chat SFC disponible en nuestro sitio web
                <a
                  class="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  target="_blank"
                  rel="noopener"
                  href="www.superfinanciera.gov.co"
                  >www.superfinanciera.gov.co</a
                >
                <br />
                Presencial en la Calle 7 # 4-49 Piso 1 - Punto Ciudadano –
                Bogotá Conmutador: +57 601 594 0200 +57 601 3508166 Línea
                gratuita nacional: 018000120100 Horario de lunes a viernes de
                8:00 a.m. a 6:00 p.m. jornada continua.
              </p>
            </div>
          </a-timeline-item>
        </a-timeline>
      </div>
      <hr class="border-t border-blue-200 mt-1 mb-3 flex-shrink-0" />
      <div class="text-center flex-shrink-0">
        <button
          @click="$emit('close')"
          class="mt-2 py-2 px-4 border-2 border-blue-500 text-blue-500 hover:bg-blue-50 rounded-lg transition duration-200"
        >
          VOLVER
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: "DataPurposeModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
